import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const AreYouReady = () => {
  const whatsappMessage =
    'Hola, me interesa la propuesta corporativa de cobertura de TNO Business para Expo Petróleo Maracaibo 2026.';

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom align="center">
          ¿Listo para que su marca sea el referente de la Expo?
        </Typography>
        <Typography
          align="center"
          color="textSecondary"
          variant="h6"
          sx={{ maxWidth: 760, mx: 'auto' }}
        >
          Conectamos su ingeniería con el mundo de los negocios. Su stand puede
          convertirse en una plataforma de autoridad, visibilidad y validación
          corporativa con el sello de TNO Business.
        </Typography>
      </Box>
      <Box maxWidth={560} margin="0 auto">
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          gap={2}
          justifyContent="center"
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            sx={{ height: 54 }}
            onClick={() =>
              window.open(
                `https://wa.me/584123964576?text=${encodeURIComponent(
                  whatsappMessage
                )}`,
                '_blank'
              )
            }
          >
            Solicitar propuesta corporativa
          </Button>
          <Button
            href="https://www.tnonetwork.com"
            variant="outlined"
            color="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ height: 54 }}
            fullWidth
          >
            Conocer TNO Network
          </Button>
        </Box>
      </Box>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
